<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF MONTHLY FORECAST</b></h5>
    <hr />
    <TableMonthlyForecastIndex
      :fields="fields.fields"
      :type="`main`"
      :filter="this.filter"
      :page="this.page"
      :name="this.name" />
  </b-card>
</template>

<script>
import TableMonthlyForecastIndex from "@/table/admin/monthlyForecast/TableMonthlyForecastIndex";

export default {
  data() {
    return {
      year: "",
      months: "",
      selected: null,
      items: [],
      month: [
        { value: null, text: "Please select an option" },
        { value: "1", text: "January" },
        { value: "2", text: "February" },
        { value: "3", text: "March" },
        { value: "4", text: "April" },
        { value: "5", text: "May" },
        { value: "6", text: "June" },
        { value: "7", text: "July" },
        { value: "8", text: "August" },
        { value: "9", text: "September" },
        { value: "10", text: "Octobber" },
        { value: "11", text: "November" },
        { value: "12", text: "December" }
      ],
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Month",
            key: "month",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      // Filter
      filter: "",
      page: "",
      name: ""
    };
  },
  created() {
    this.week();

    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.name = this.$route.query.name;
    }
    // this.getMF();
  },
  methods: {
    week() {
      // month_number is in the range 1..12
      var d = new Date();
      var m = d.getMonth();
      var n = d.getFullYear();
      this.year = n;
      this.months = m;

      var firstOfMonth = new Date(this.year, this.months - 1, 1);
      var lastOfMonth = new Date(this.year, this.months, 0);
      var used = firstOfMonth.getDay() + lastOfMonth.getDate();
      this.weeks = Math.ceil(used / 7);
    }
  },
  components: {
    TableMonthlyForecastIndex
  }
};
</script>
<style lang="css" scoped></style>
